import { render, staticRenderFns } from "./AdvisorDetail.vue?vue&type=template&id=12c98aae"
import script from "./AdvisorDetail.vue?vue&type=script&lang=js"
export * from "./AdvisorDetail.vue?vue&type=script&lang=js"
import style0 from "./AdvisorDetail.vue?vue&type=style&index=0&id=12c98aae&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports